var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgErrorZ(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 190,
    height: 151,
    viewBox: "0 0 190 151",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 182.413,
    height: 129.695,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "d"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 2.967,
    height: 11.22,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "f"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 9.695,
    height: 6.889,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "g"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 90.959,
    height: 85.642,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "j"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 190,
    height: 151
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "i",
    clipPath: "url(#j)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 190,
    height: 151,
    fill: "rgba(255,255,255,0)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(3.793 6)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)",
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M31.375,129.694H151.788a27.887,27.887,0,0,0,21.486-10.064c11.687-14.109,20.947-43.98-30.43-95.357C120.256,1.685,66-16.033,60,22.984,52.853,69.464,16.868,34.257,2.1,80.358c-5.434,16.961.649,30.152,7.256,38.609a27.937,27.937,0,0,0,22.02,10.726",
    transform: "translate(0 0.001)",
    fill: "#97a0fb"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M122.955,676.073h-3.288a16.838,16.838,0,0,1-16.892-16.745,22.217,22.217,0,0,1,5.828-14.8,39.5,39.5,0,0,1,12.088-8.987,78.676,78.676,0,0,1,13.9-5.332,106.6,106.6,0,0,1,16.354-3.358l.422,3.934a104.685,104.685,0,0,0-15.747,3.245c-11.062,3.183-19.37,7.708-24.027,13.087a18.373,18.373,0,0,0-4.863,12.21,12.877,12.877,0,0,0,12.935,12.789h3.288Z",
    transform: "translate(-91.157 -555.99)",
    fill: "#4251a4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M408.762,234.619H315.31a17.7,17.7,0,0,1-15.324-26.543l3.938-6.822,1.618-2.8,41.171-71.309a17.7,17.7,0,0,1,30.648,0l9.251,16.025,8.271,14.327,12.047,20.866,2.194,3.8,14.94,25.878.022.037a17.993,17.993,0,0,1,1.788,4.273,17.715,17.715,0,0,1-17.113,22.27",
    transform: "translate(-263.948 -104.924)",
    fill: "#f5af23"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M277.46,1027.337v3.939H252.028q-.238-.625-.449-1.26-.454-1.368-.837-2.679Z",
    transform: "translate(-222.397 -911.203)",
    fill: "#4251a4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M552.076,953.825c0,6.4,2.377,11.591,5.308,11.591s5.309-5.189,5.309-11.591-2.377-11.591-5.309-11.591-5.308,5.189-5.308,11.591",
    transform: "translate(-489.667 -835.721)",
    fill: "#4251a4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M438.463,953.825a19.964,19.964,0,0,0,.457,4.3c.946,4.271,3.259,7.288,5.964,7.288h11.731c-2.932,0-5.308-5.189-5.308-11.591s2.377-11.591,5.308-11.591H444.884c-2.7,0-5.018,3.017-5.964,7.288a19.963,19.963,0,0,0-.457,4.3",
    transform: "translate(-388.898 -835.721)",
    fill: "#97a0fb"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(66.234 112.495)",
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#d)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M585.912,996.624a1.484,1.484,0,1,0,1.484-1.484,1.484,1.484,0,0,0-1.484,1.484",
    transform: "translate(-585.912 -995.14)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M585.912,1069.626a1.484,1.484,0,1,0,1.484-1.484,1.484,1.484,0,0,0-1.484,1.484",
    transform: "translate(-585.912 -1059.89)"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(66.234 112.495)",
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#d)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M585.912,996.624a1.484,1.484,0,1,0,1.484-1.484,1.484,1.484,0,0,0-1.484,1.484",
    transform: "translate(-585.912 -995.14)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M585.912,1069.626a1.484,1.484,0,1,0,1.484-1.484,1.484,1.484,0,0,0-1.484,1.484",
    transform: "translate(-585.912 -1059.89)"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M407.368,1010.717c0,2.4,1.574,4.34,3.515,4.34a2.78,2.78,0,0,0,.457-.037,20.474,20.474,0,0,1,0-8.6,2.767,2.767,0,0,0-.457-.037c-1.942,0-3.515,1.942-3.515,4.339",
    transform: "translate(-361.318 -892.613)",
    fill: "#6373c1"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(51.368 114.66)",
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#f)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M454.409,1017.741c0,1.9,2.17,3.444,4.848,3.444s4.848-1.542,4.848-3.444-2.17-3.444-4.848-3.444-4.848,1.542-4.848,3.444",
    transform: "translate(-454.409 -1014.297)"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(39.976 13.373)",
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#g)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M444.593,157.5a77.16,77.16,0,0,1-90.959,43.758l1.618-2.8,41.171-71.309a17.7,17.7,0,0,1,30.648,0l9.252,16.025Z",
    transform: "translate(-353.634 -118.297)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M816.612,319.14h0a4.92,4.92,0,0,1-4.849-4.772l-1.553-35.239a6.419,6.419,0,1,1,12.8,0l-1.553,35.239a4.92,4.92,0,0,1-4.849,4.772",
    transform: "translate(-718.615 -241.458)",
    fill: "#4251a4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M829.554,742.717a5.533,5.533,0,1,1-5.531-5.7,5.615,5.615,0,0,1,5.531,5.7",
    transform: "translate(-725.967 -653.706)",
    fill: "#4251a4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1047.769,663.22a21.438,21.438,0,0,0-8.257-11.575,20.279,20.279,0,0,0-14.157-3.307l2.194,3.8c8.734-.264,14.486,5.678,16.428,12.21a17.251,17.251,0,0,1-1.488,13.668,17,17,0,0,1-8.072,6.867c-9.36,4.076-22.677,6.144-39.585,6.144v3.957c17.454,0,31.3-2.178,41.165-6.473a21.624,21.624,0,0,0,8.3-6.185,19.5,19.5,0,0,0,2.877-4.864,21.491,21.491,0,0,0,.594-14.242",
    transform: "translate(-882.372 -574.901)",
    fill: "#4251a4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M822.362,1026.839a5.261,5.261,0,0,1,0,4.052h-1.58v-4.052Z",
    transform: "translate(-727.999 -910.761)",
    fill: "#707c82"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M773.781,953.824a24.637,24.637,0,0,0,.138,2.63,21.141,21.141,0,0,0,.528,2.991c.905,3.56,2.646,5.969,4.643,5.969,2.932,0,5.308-5.189,5.308-11.59s-2.376-11.591-5.308-11.591c-2,0-3.741,2.414-4.646,5.981a21.241,21.241,0,0,0-.527,2.99,24.9,24.9,0,0,0-.136,2.62",
    transform: "translate(-686.31 -835.719)",
    fill: "#4251a4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M740.971,996.646a1.483,1.483,0,0,0,1.484,1.484h7.534v-.023a1.484,1.484,0,1,0,0-2.967h-7.534v.023a1.483,1.483,0,0,0-1.484,1.484",
    transform: "translate(-657.209 -882.644)",
    fill: "#aec7d3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M742.455,1068.073v-.035h7.534v.012a1.484,1.484,0,1,1,0,2.967v.012h-7.356a1.483,1.483,0,1,1-.177-2.956",
    transform: "translate(-657.209 -947.303)",
    fill: "#aec7d3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M820.74,965.413h11.731c2.7,0,5.018-3.017,5.964-7.288a20.477,20.477,0,0,0,0-8.6c-.946-4.271-3.259-7.288-5.964-7.288H820.74c2.932,0,5.308,5.189,5.308,11.591s-2.376,11.591-5.308,11.591",
    transform: "translate(-727.961 -835.718)",
    fill: "#97a0fb"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M981.241,1010.718a5.149,5.149,0,0,1-.405,2.026,3.5,3.5,0,0,1-3.11,2.314,2.809,2.809,0,0,1-.457-.037,20.477,20.477,0,0,0,0-8.6,2.673,2.673,0,0,1,.457-.037,3.5,3.5,0,0,1,3.109,2.313,5.129,5.129,0,0,1,.406,2.026",
    transform: "translate(-866.795 -892.614)",
    fill: "#6373c1"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(99.648 114.66)",
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#f)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M881.5,1017.739c0,1.9,2.17,3.444,4.848,3.444s4.848-1.542,4.848-3.444-2.17-3.444-4.848-3.444-4.848,1.542-4.848,3.444",
    transform: "translate(-881.498 -1014.295)"
  }))))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgErrorZ);
export default __webpack_public_path__ + "static/media/errorZ.3f7ca8f13c2e9092777d22eabfe66bf2.svg";
export { ForwardRef as ReactComponent };